<template>
  <app-collapse>
    <app-collapse-item
      :is-visible="true"
      :title="label"
    >
      <ckeditor
        :id="id"
        v-model="selfValue"
        :editor="editor"
        :config="editorConfig"
      />
    </app-collapse-item>
  </app-collapse>
</template>

<script>
import 'bootstrap-vue'
import CKEditor from '@ckeditor/ckeditor5-vue2'
import ClassicEditor from '@ckeditor/ckeditor5-build-inline'
import { uploader } from '@/@core/utils/UploadAdapter'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'

export default {
  name: 'CkeditorBasic',
  components: {
    ckeditor: CKEditor.component,
    AppCollapseItem,
    AppCollapse,
  },
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    id: {
      type: [String, Number],
      default: '',
    },
    config: {
      type: Object,
      default: () => ({}),
    },
    label: {
      type: String,
      default: '',
    },
    value: null, // any value type
  },
  data() {
    return {
      selfValue: null,
      editor: ClassicEditor,
      defaultConfig: {
        fillEmptyBlocks: false,
        basicEntities: false,
        entities: false,
        entities_greek: false,
        entities_latin: false,
        entities_additional: '',
        language: 'fa',
        extraPlugins: [uploader],
      },
    }
  },
  computed: {
    editorConfig() {
      return {
        ...this.defaultConfig,
        ...this.config,
      }
    },
  },
  watch: {
    value: {
      handler(val) {
        this.selfValue = val
      },
      immediate: true,
    },
    selfValue(val) {
      this.$emit('input', val)
    },
  },
}
</script>
